import { render, staticRenderFns } from "./ObjectFileItem.vue?vue&type=template&id=cf7493b0&scoped=true&"
import script from "./ObjectFileItem.vue?vue&type=script&lang=js&"
export * from "./ObjectFileItem.vue?vue&type=script&lang=js&"
import style0 from "./ObjectFileItem.vue?vue&type=style&index=0&id=cf7493b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7493b0",
  null
  
)

export default component.exports